import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import './staffAugmentation.scss';
import ButtonComponent from '../../Components/Button/button';
import DownloadIcon from '../../Assets/images/svg/download.svg';
import { handleJDDownload } from './staffAugmentationUtils';

const JobDescriptionView = ({ modalOpen, fileUrl, handleClose }) => {
  return (
    <div>
      <Dialog
        open={modalOpen}
        onClose={handleClose}
        PaperProps={{
          className: 'dialog-paper',
        }}
      >
        <header>
          <div className="staff-aug-jd-header-container">
            <span className="staff-aug-jd-dialog-title">Job Description</span>
            <ButtonComponent
              label="Download"
              variant="text"
              btnCss="staff-aug-jd-cancel-btn"
              id="jd-download"
              startIcon={<img src={DownloadIcon} alt="Download JD" />}
              onClick={() => handleJDDownload(fileUrl)}
            />
          </div>
        </header>
        <DialogContent className="staff-aug-jd-dialog-content">
          <div>
            <iframe
              src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              height="600px"
              title="Document Viewer"
              style={{ border: 'none' }}
            />
          </div>
        </DialogContent>
        <DialogActions className="staff-aug-jd-dialog-actions">
          <ButtonComponent
            label="Close"
            variant="text"
            onClick={handleClose}
            btnCss="staff-aug-jd-cancel-btn"
            id="jd-dialog-close"
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

JobDescriptionView.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  fileUrl: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default JobDescriptionView;
